import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import { useControllableProp, useId } from "@chakra-ui/hooks";
import { isInputEvent, mergeRefs } from "@chakra-ui/utils";
import { useCallback, useRef, useState } from "react";
/**
 * React hook to manage a group of radio inputs
 */

export function useRadioGroup(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      onChangeProp = _props.onChange,
      valueProp = _props.value,
      defaultValue = _props.defaultValue,
      nameProp = _props.name,
      isNative = _props.isNative,
      htmlProps = _objectWithoutPropertiesLoose(props, ["onChange", "value", "defaultValue", "name", "isNative"]);

  var _useState = useState(defaultValue || ""),
      _useState2 = _slicedToArray(_useState, 2),
      valueState = _useState2[0],
      setValue = _useState2[1];

  var _useControllableProp = useControllableProp(valueProp, valueState),
      _useControllableProp2 = _slicedToArray(_useControllableProp, 2),
      isControlled = _useControllableProp2[0],
      value = _useControllableProp2[1];

  var ref = useRef(null);
  var focus = useCallback(function () {
    var rootNode = ref.current;
    if (!rootNode) return;
    var query = "input:not(:disabled):checked";
    var firstEnabledAndCheckedInput = rootNode.querySelector(query);

    if (firstEnabledAndCheckedInput) {
      firstEnabledAndCheckedInput.focus();
      return;
    }

    query = "input:not(:disabled)";
    var firstEnabledInput = rootNode.querySelector(query);
    firstEnabledInput == null ? void 0 : firstEnabledInput.focus();
  }, []);
  /**
   * All radio options must use the same name
   */

  var fallbackName = useId(undefined, "radio");
  var name = nameProp || fallbackName;
  var onChange = useCallback(function (eventOrValue) {
    var nextValue = isInputEvent(eventOrValue) ? eventOrValue.target.value : eventOrValue;

    if (!isControlled) {
      setValue(nextValue);
    }

    onChangeProp == null ? void 0 : onChangeProp(nextValue);
  }, [onChangeProp, isControlled]);

  var getRootProps = function getRootProps(props, forwardedRef) {
    if (props === void 0) {
      props = {};
    }

    if (forwardedRef === void 0) {
      forwardedRef = null;
    }

    return _extends({}, props, {
      ref: mergeRefs(forwardedRef, ref),
      role: "radiogroup"
    });
  };

  var getRadioProps = function getRadioProps(props, ref) {
    var _extends2;

    if (props === void 0) {
      props = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    var checkedKey = isNative ? "checked" : "isChecked";
    return _extends({}, props, (_extends2 = {
      ref: ref,
      name: name
    }, _defineProperty(_extends2, checkedKey, props.value === value), _defineProperty(_extends2, "onChange", onChange), _extends2));
  };

  return {
    getRootProps: getRootProps,
    getRadioProps: getRadioProps,
    name: name,
    ref: ref,
    focus: focus,
    setValue: setValue,
    value: value,
    onChange: onChange,
    htmlProps: htmlProps
  };
}